var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 139 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #150093;\n      }\n\n      .st2 {\n        fill: #150092;\n      }\n\n      .st3 {\n        fill: #ffa0d8;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.8,42.6H57.3v5.8h81.5v-5.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.8,47.2v-3.3h1.5c.6,0,1,.5,1,1s-.1.5-.2.6c.2.2.3.5.3.8,0,.6-.5,1-1,1h-1.6ZM61.2,45.1c.1,0,.3-.1.3-.3s-.1-.3-.3-.3h-.5v.6h.5ZM61.3,46.4c.1,0,.3-.1.3-.3s-.1-.3-.3-.3h-.6v.6h.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63,43.7h.9v2.5h1.3v.9h-2.1v-3.5h-.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.3,43.7c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7-1.7-.8-1.7-1.7.8-1.7,1.7-1.7ZM67.3,44.7c-.5,0-.8.3-.8.8s.3.8.8.8.8-.3.8-.8-.3-.8-.8-.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.7,44.9c-.1-.1-.3-.2-.6-.2-.5,0-.8.3-.8.8s.3.8.8.8.5-.1.6-.2l.6.6c-.3.3-.7.5-1.2.5-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7.9.2,1.2.5l-.6.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.3,43.7l-1.5,1.5,1.8,1.8h-1.3l-1.2-1.2-.3.2v1h-.9v-3.3h.9v1.2l1.2-1.2h1.3Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.8,44.9c-.1-.1-.3-.2-.6-.2-.5,0-.8.3-.8.8s.3.8.8.8.5-.1.6-.2l.6.6c-.3.3-.7.5-1.2.5-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7.9.2,1.2.5l-.6.8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81,43.7v1.2h1v-1.2h.9v3.3h-.9v-1.3h-1v1.3h-.9v-3.3h.9Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.4,47.2l1.6-3.3h.3l1.6,3.3h-.9l-.2-.5h-1.4l-.2.5h-.8ZM84.9,45.9h.7l-.3-.7-.3.7Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.5,43.7h.9v3.3h-.9v-3.3Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.5,47.2l-1.5-1.6v1.6h-.9v-3.3h.3l1.6,1.6v-1.6h.9v3.3h-.5Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94,43.7h2.1v.7h-1.3v.6h1v.7h-1v.6h1.3v.7h-2.1v-3.2Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100,43.7l-1.6,3.3h-.3l-1.6-3.3h.9l.9,2,.9-2h.8Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.4,43.7h2.1v.7h-1.3v.6h1v.7h-1v.6h1.3v.7h-2.1v-3.2Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.7,47.2l-1.6-1.6v1.6h-.9v-3.3h.3l1.6,1.6v-1.6h.9v3.3h-.3Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.6,43.7h2.7v.9h-.9v2.5h-.9v-2.5h-.9v-.9h.1Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.3,44.8c0-.1-.1-.2-.2-.2s-.2.1-.2.2.1.2.2.2c.3,0,.6.1.8.3.1.2.2.5.2.7,0,.6-.5,1-1,1s-1-.5-1-1h.8c0,.1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2c-.6,0-1-.5-1-1s.5-1,1-1,1,.5,1,1h-.8Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.7,43.7h.9v3.3h-.9v-3.3Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.8,47.2l-1.6-1.6v1.6h-.9v-3.3h.3l1.6,1.6v-1.6h.9v3.3h-.3Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.8,44.9c-.1-.1-.3-.2-.6-.2-.5,0-.8.3-.8.8s.3.8.8.8.5-.1.6-.2l.6.6c-.3.3-.7.5-1.2.5-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7.9.2,1.2.5l-.6.8Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.1,43.7h2.1v.7h-1.3v.6h1v.7h-1v.6h1.3v.7h-2.1v-3.2Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.3,45.2c.1-.1.1-.2.1-.3s-.1-.3-.3-.3-.3.2-.3.3h-.7c0-.6.5-1.2,1.2-1.2s1.2.6,1.2,1.2-.2.6-.2.6l-.7.9h.9v.7h-2.3l1.3-1.8Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.9,44.9c0-.6.5-1.2,1.2-1.2s1.2.5,1.2,1.2v1.2c0,.6-.5,1.2-1.2,1.2s-1.2-.5-1.2-1.2v-1.2ZM129.6,46c0,.2.2.3.3.3.2,0,.3-.2.3-.3v-1.2c0-.2-.2-.3-.3-.3-.2,0-.3.2-.3.3v1.2Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.2,43.7h.9v3.3h-.9v-3.3Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.1,45.9c-.6-.1-.9-.6-.9-1s.5-1.2,1.2-1.2,1.2.5,1.2,1.2-.1.3-.1.6l-1,1.7h-.8l.6-1.3ZM135.2,45.2c.2,0,.3-.1.3-.3s-.2-.3-.3-.3c-.2,0-.3.2-.3.3,0,.2.1.3.3.3Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.2,31.3l4.5-4.2h1.3v11.1h-2.9v-5.7l-2.9,2.7-2.9-2.7v5.7h-2.9v-11.1h1.3l4.5,4.2Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.2,27.1c3.1,0,5.5,2.5,5.5,5.5s-2.5,5.5-5.5,5.5-5.5-2.4-5.5-5.5,2.4-5.5,5.5-5.5ZM76.2,30c-1.5,0-2.7,1.2-2.7,2.7s1.2,2.7,2.7,2.7,2.7-1.2,2.7-2.7c-.1-1.5-1.3-2.7-2.7-2.7Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.8,33.8c0,.8.7,1.5,1.5,1.5s1.5-.7,1.5-1.5v-6.7h2.9v6.7c0,2.4-2,4.4-4.4,4.4s-4.4-2-4.4-4.4v-6.7h2.9v6.7Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.5,38.2l-5.2-5.2v5.2h-2.9v-11.1h1.2l5.2,5.2v-5.2h2.9v11.1h-1.2Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.2,27.1h8.8v2.9h-3v8.2h-2.9v-8.2h-2.9v-2.9Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.2,38.2l5.2-11.1h1.3l5.2,11.1h-2.9l-.7-1.5h-4.5l-.7,1.5h-2.9ZM116.9,34.3h2.3l-1.2-2.4-1.2,2.4Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.8,27.1h2.9v11.1h-2.9v-11.1Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.7,38.2l-5.2-5.2v5.2h-2.9v-11.1h1.2l5.2,5.2v-5.2h2.9v11.1h-1.2Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.3,22.7v-11.1h5c1.7,0,3.2,1.5,3.2,3.3s-.2,1.5-.7,2c.8.6,1.3,1.5,1.3,2.5,0,1.7-1.5,3.2-3.2,3.2h-5.5ZM61.7,16c.6,0,.9-.5.9-.9s-.5-.9-.9-.9h-1.4v2h1.4ZM62.2,20.3c.6,0,.9-.5.9-.9s-.3-.9-.9-.9h-2v2h2Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.4,11.7h2.9v8.2h4v2.9h-6.9v-11.1Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.8,11.7c3.1,0,5.5,2.5,5.5,5.5s-2.5,5.5-5.5,5.5-5.5-2.4-5.5-5.5,2.4-5.5,5.5-5.5ZM80.8,14.5c-1.5,0-2.7,1.2-2.7,2.7s1.2,2.7,2.7,2.7,2.7-1.2,2.7-2.7-1.2-2.7-2.7-2.7Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.7,15.3c-.5-.5-1.2-.7-1.8-.7-1.5,0-2.7,1-2.7,2.7s1,2.7,2.7,2.7,1.4-.2,1.8-.7l2.1,2.1c-1,1-2.4,1.6-3.9,1.6-3.1,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5,2.9.6,3.9,1.6l-2.1,1.8Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.3,11.7l-5.1,5.1,6,6h-4l-3.9-3.9-.7.7v3.2h-2.9v-11.1h2.9v3.7l3.7-3.7h4Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.7,0L0,41.1l24.7,18.9,24.7-18.9L24.7,0Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.7,24.7l18.6,15.5h-18.6l2.4-7.3-2.4-8.2Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.7,2.1L1.4,40.7l23.3,17.9,23.3-17.9L24.7,2.1ZM4,39.7L24.7,5.4l20.7,34.3-20.7-17.4L4,39.7ZM24.7,40.2l2.4-7.3-2.4-8.2,18.6,15.6h-18.6Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M4,39.7l20.7-17.4,20.7,17.4L24.7,5.4,4,39.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0860bda44adfcc1592b814e376e3ea38.svg";
export { ForwardRef as ReactComponent };